import './auth-patreon.scss';

import { Text, Link } from "@ui-kit";

const AuthPatreon = () => {
  const app1 = process.env.REACT_APP_PATREON_NAME;
  const redirectUrl1 = process.env.REACT_APP_PATREON_REDIRECT;
  const app2 = process.env.REACT_APP_MAX_PATREON_NAME;
  const redirectUrl2 = process.env.REACT_APP_MAX_PATREON_REDIRECT;
  const app3 = process.env.REACT_APP_TEST_PATREON_NAME;
  const redirectUrl3 = process.env.REACT_APP_TEST_PATREON_REDIRECT;

  return (
    <div className="auth-patreon">
      <div className="auth-patreon__header mb-24">
        <Text as="h5" className="subtitle mb-12">
          Click "Start Auth Patreon" to authorize the Patreon app.
        </Text>
      </div>

      <div className="auth-patreon__content">
        <Link to={redirectUrl1} target="_blank" rel="noreferrer">
          Start Auth {app1}
        </Link>
        <Link to={redirectUrl2} target="_blank" rel="noreferrer">
          Start Auth {app2}
        </Link>
        <Link to={redirectUrl3} target="_blank" rel="noreferrer">
          Start Auth {app3}
        </Link>
      </div>
    </div>
  );
};

export default AuthPatreon;
